import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiAssignmentBodyModel } from '@/types'

export const postKpiAssignments = async (
  assignments: KpiAssignmentBodyModel[]
): Promise<void> => {
  try {
    await axios.post(`${BASE_URL}/kpi/assignments/`, assignments)
  } catch (error) {
    console.error('Error posting KPI assignments:', error)
    throw error
  }
}
